module.exports = __webpack_public_path__ + "img/kt2.502622a8.png";